import { useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import './header.scss';
import SecurityHotline from './securityHotline/SecurityHotline';
// 适配移动端
import '../../../phone/appointmentManagement/compentent/header/header.scss';
interface headerProps {
    childrenKeys: string[];
    selectedKey: string;
    pathName: string;
    unreadCount: number;
    updateInfo: null | Record<string, any>;
    userData: null | Record<string, any>;
    openLogoutAlertevent: () => void;
    isShowNavEvent: () => void;
}
const header = React.memo(({updateInfo,userData,openLogoutAlertevent}:headerProps) => {
    const [showSelect, setShowSelect] = useState(false);
    const userOperationList = [
        { id: '2', title: 'Log out',img:require("../../../../assets/appointmentManagement/header/logout.png")},
      ];
    // 点击头像位置打开弹窗，点击其他位置关闭弹窗
    const handleClickSelect = () => {
        setShowSelect(!showSelect);
    }
    useEffect(()=>{
        const handleClickOther = (e:any) => {
            if(e.target.closest('.select-img-mouse')){
                return;
            }
            setShowSelect(false);
        }
        document.addEventListener('click', handleClickOther);
        return () => document.removeEventListener('click', handleClickOther);
    },[showSelect])
    return (
        <div className="header-main">
            {
                // pc端
                <div className="header-pc header-content">
                    <div className="header-title-left">
                        Hello 👏🏻
                    </div>
                    <div className="header-actions">
                        <SecurityHotline />
                        <div className="user-img">
                            {/* pc用户个人信息操作入口*/}
                            <div className="select-img-mouse" 
                                // onMouseEnter={() => {
                                //     setShowSelect(true);
                                // }} onMouseLeave={() => {
                                //     setShowSelect(false);
                                // }}
                                >
                                <div className="select-user-img">
                                    <div className="select-input-content-img" onClick={handleClickSelect}>
                                            {
                                                (updateInfo?.avatar || userData?.avatar) ? (
                                                    <img src={updateInfo?.avatar ? updateInfo.avatar : userData?.avatar} 
                                                    onError={(e) => {
                                                        e.currentTarget.src = require("../../../../assets/appointmentManagement/header/userDefultImg.png");
                                                    }}
                                                    alt="" />
                                                ) : (
                                                    <img src={require("../../../../assets/appointmentManagement/header/userDefultImg.png")} alt="" />
                                                )
                                            }
                                    </div>
                                    {
                                        showSelect && (
                                            <div className="select-input-content-option" 
                                            // onMouseEnter={() => {
                                            // setShowSelect(true);
                                            // }} onMouseLeave={() => {
                                            // setShowSelect(false);
                                            // }}
                                            >
                                            {userOperationList.map((item: any,index:number) => (
                                                <div className="select-input-content-option-item" onClick={()=>{
                                                    setShowSelect(false);
                                                    openLogoutAlertevent();
                                                }}>
                                                <img src={item.img} alt="" />
                                                <span>{item.title}</span>
                                            </div>
                                            ))}
                                            </div>
                                        )
                                    }
                                </div>
                        </div>
                        </div>
                    </div>
                </div>
            }   
        </div>
    )
})
export default header;
